export default __webpack_public_path__ + "static/media/bookMixed.3e04bc47.svg";